import { Reporting } from '@/pages'
import { reportingSearchSchema } from '@/schemas'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_layout/reporting/')({
    component: Reporting,
    validateSearch: reportingSearchSchema,
})
